const COOKIE_IMPORT_OFFERED_KEY = "wildlark:browser-start-cookie-import-offered:v1"

export function shouldOfferBrowserCookieImport(): boolean {
    if (typeof window === "undefined") return false
    try {
        return window.localStorage.getItem(COOKIE_IMPORT_OFFERED_KEY) === null
    } catch {
        return false
    }
}

export function markBrowserCookieImportOffered(): void {
    if (typeof window === "undefined") return
    try {
        window.localStorage.setItem(COOKIE_IMPORT_OFFERED_KEY, String(Date.now()))
    } catch {
        // Starting Browser must still work when Web storage is unavailable.
    }
}
